import { useGetAiReviewChatQuery } from '@app-velocity/libs/review-data-access';

import { useAiChatContext } from './useAiChatContext';

export const useAiChat = () => {
    const { scenario, review } = useAiChatContext();

    const { data: chat, isLoading: isChatLoading, refetch } = useGetAiReviewChatQuery(
        scenario?.shareToken,
        review?.reviewId,
        review?.reviewStatus === 'IN_PROGRESS'
    );

    const assistantMessages = chat ? chat.filter(message => message.pageId && message.messageType === 'ASSISTANT') : [];

    return { messages: assistantMessages, isLoading: isChatLoading, refetch }

}